import { Typography, TypographyProps } from '@mui/material';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

export interface LinkProps extends Omit<RouterLinkProps, 'target'> {
  children: React.ReactNode;
  target?: HTMLAnchorElement['target'];
  disabled?: boolean;
  style?: React.CSSProperties;
  typographyProps?: Omit<TypographyProps, 'children'>;
}

const Link = ({ children, target, typographyProps, style, disabled, ...rest }: LinkProps) => {
  return (
    <RouterLink
      target={target}
      style={style}
      className={disabled ? 'cursor-not-allowed pointer-events-none	' : ''}
      {...rest}>
      <Typography {...typographyProps}>{children}</Typography>
    </RouterLink>
  );
};

export default Link;
